import React from "react";
import DashboardIcon from "../../../img/v2/Dashboard.svg";
import MaListeIcon from "../../../img/v2/MaListe.svg";
import MesSondagesIcon from "../../../img/v2/MesSondages.svg";
import MesAvisIcon from "../../../img/v2/MesAvis.svg";
import GestionEauIcon from "../../../img/v2/GestionEau.svg";
import GestionMenageIcon from "../../../img/v2/GestionMenage.svg";
import VentesAddIcon from "../../../img/v2/VentesAdd.svg";
import PourboiresIcon from "../../../img/v2/Pourboires.svg";
import MesDonsIcon from "../../../img/v2/MesDons.svg";
import EconomiesIcon from "../../../img/v2/Economies.svg";
import GreenMilesIcon from "../../../img/v2/gm_logo.svg";
import HotelIcon from "../../../img/v2/hotel.svg";

// Mapping des clés de pages vers leurs icônes
const iconMap = {
  "my-hotels": HotelIcon,
  dashboard: DashboardIcon,
  greenmiles: GreenMilesIcon,
  economies: EconomiesIcon,
  "actions-list": MaListeIcon,
  "actions-surveys": MesSondagesIcon,
  "actions-reviews": MesAvisIcon,
  "actions-water": GestionEauIcon,
  "actions-cleaning": GestionMenageIcon,
  "rewards-list": MaListeIcon,
  "rewards-sales": VentesAddIcon,
  "rewards-tips": PourboiresIcon,
  "rewards-donations": MesDonsIcon,
};

const SidebarItem = ({ item, isActive, onSelect }) => {
  const handleClick = () => onSelect(item.key);

  // Récupérer l'icône correspondante ou null si elle n'existe pas
  const Icon = iconMap[item.key] || null;

  return (
    <li className={isActive ? "v2-sidebar__item--active" : ""}>
      <div className="v2-sidebar__item-wrapper">
        <button
          type="button"
          className={`v2-sidebar__link ${isActive ? "is-active" : ""}`}
          onClick={handleClick}
        >
          {Icon ? (
            <span className={`v2-sidebar__icon ${isActive ? "is-active" : ""}`} aria-hidden="true">
              <img src={Icon} alt="" />
            </span>
          ) : (
            <span className={`v2-sidebar__indicator ${isActive ? "is-active" : ""}`} aria-hidden="true" />
          )}
          <span className="v2-sidebar__label">{item.label}</span>
          {item.badge ? (
            <span className="v2-sidebar__badge" aria-label={`${item.badge} notifications`}>
              {item.badge}
            </span>
          ) : null}
        </button>
      </div>
    </li>
  );
};

export default SidebarItem;


